/* ============================================================
   The Brillian — Öne Çıkan Ürünler "Hızlı Ekle"
   data-brillian-quick-add butonlarını AJAX ile sepete ekler ve
   tema sepet bileşenlerini (cart-drawer / cart-notification) yeniler.
   ============================================================ */
(function () {
  'use strict';

  var RECENT_PRODUCTS_KEY = 'brilian:recent-products:v2';
  var PERSONALIZED_LIMIT = 6;

  // Lansman hediyesi (numune) — "son baktıkların" / önerilerde asla gösterilmez.
  var GIFT_VARIANT_ID = 44681126805570;
  var GIFT_HANDLE = 'lansmana-ozel-tum-urun-tester-seti';

  function isGiftProduct(product) {
    if (!product) return false;
    if (product.handle === GIFT_HANDLE) return true;
    return Number(product.variantId) === GIFT_VARIANT_ID;
  }

  function readRecentProducts() {
    try {
      var stored = JSON.parse(window.localStorage.getItem(RECENT_PRODUCTS_KEY) || '[]');
      return Array.isArray(stored) ? stored : [];
    } catch (error) {
      return [];
    }
  }

  function rememberCurrentProduct() {
    var product = window.brillianProductView;
    if (!product || !product.handle || !product.available) return;
    if (isGiftProduct(product)) return;

    var recent = readRecentProducts().filter(function (item) {
      return item && item.handle !== product.handle;
    });
    recent.unshift(product);

    try {
      window.localStorage.setItem(RECENT_PRODUCTS_KEY, JSON.stringify(recent.slice(0, 10)));
    } catch (error) {
      return;
    }
  }

  function getDiscountPercent(product) {
    var price = Number(product.price) || 0;
    var compareAtPrice = Number(product.compareAtPrice) || 0;
    if (price <= 0 || compareAtPrice <= price) return 0;
    return Math.round(((compareAtPrice - price) / compareAtPrice) * 100);
  }

  function formatTemplate(template, token, value) {
    return String(template || '').split(token).join(value);
  }

  function createRecentCard(product, root) {
    var article = document.createElement('article');
    var media = document.createElement('a');
    var image = document.createElement('img');
    var badge = document.createElement('span');
    var body = document.createElement('div');
    var title = document.createElement('a');
    var prices = document.createElement('div');
    var price = document.createElement('span');
    var button = document.createElement('button');
    var buttonLabel = document.createElement('span');
    var buttonIcon = document.createElement('span');

    article.className = 'br-cart-recommendation is-recent';
    article.dataset.brRecentGenerated = 'true';
    article.dataset.productHandle = product.handle;

    media.className = 'br-cart-recommendation__media';
    media.href = product.url;
    media.setAttribute('aria-label', product.title);

    image.src = product.image;
    image.alt = product.imageAlt || product.title;
    image.loading = 'lazy';
    image.width = 440;
    image.height = 378;

    badge.className = 'br-cart-recommendation__badge';
    badge.dataset.brCardBadge = '';

    body.className = 'br-cart-recommendation__body';
    title.className = 'br-cart-recommendation__title';
    title.href = product.url;
    title.textContent = product.title;

    prices.className = 'br-cart-recommendation__prices';
    price.className = 'br-cart-recommendation__price';
    price.textContent = product.priceFormatted;
    prices.appendChild(price);
    if (Number(product.compareAtPrice) > Number(product.price)) {
      var compareAt = document.createElement('s');
      compareAt.textContent = product.compareAtPriceFormatted;
      prices.appendChild(compareAt);
    }

    button.type = 'button';
    button.className = 'br-cart-recommendation__add';
    button.dataset.brillianQuickAdd = '';
    button.dataset.variantId = product.variantId;
    button.setAttribute(
      'aria-label',
      formatTemplate(root.dataset.addTemplate, '__TITLE__', product.title)
    );
    buttonLabel.textContent = root.dataset.addLabel;
    buttonIcon.textContent = '+';
    buttonIcon.setAttribute('aria-hidden', 'true');

    media.appendChild(image);
    media.appendChild(badge);
    body.appendChild(title);
    body.appendChild(prices);
    button.appendChild(buttonLabel);
    button.appendChild(buttonIcon);
    article.appendChild(media);
    article.appendChild(body);
    article.appendChild(button);
    return article;
  }

  function getRecentBadge(root, product) {
    var recentLabel = root.dataset.recentBadge || '';
    var discount = getDiscountPercent(product);
    if (!discount) return recentLabel;
    var discountLabel = formatTemplate(root.dataset.discountTemplate, '__PERCENT__', discount);
    return recentLabel + ' · ' + discountLabel;
  }

  function initCartPersonalization() {
    var root = document.querySelector('[data-br-cart-personalized]');
    if (!root) return;

    var track = root.querySelector('[data-br-personalized-track]');
    if (!track) return;

    var cartHandles = Array.prototype.map.call(
      document.querySelectorAll('#CartDrawer .cart-item[data-product-handle]'),
      function (item) { return item.dataset.productHandle; }
    );
    var recent = readRecentProducts().filter(function (product) {
      return product && product.handle && product.available && !isGiftProduct(product) && cartHandles.indexOf(product.handle) === -1;
    });
    var fallbackCards = Array.prototype.slice.call(track.querySelectorAll('[data-br-cart-candidate]'));
    var signature = cartHandles.join('|') + '::' + recent.map(function (item) { return item.handle; }).join('|') + '::' + fallbackCards.map(function (item) { return item.dataset.productHandle; }).join('|');
    if (root.dataset.brPersonalizedSignature === signature) return;
    root.dataset.brPersonalizedSignature = signature;

    Array.prototype.forEach.call(track.querySelectorAll('[data-br-recent-generated]'), function (card) {
      card.remove();
    });
    fallbackCards.forEach(function (card) {
      card.hidden = true;
      card.classList.remove('is-recent');
    });

    var selected = [];
    var selectedHandles = [];
    var recentUsed = 0;

    recent.some(function (product) {
      if (selected.length >= PERSONALIZED_LIMIT) return true;
      var card = fallbackCards.find(function (candidate) {
        return candidate.dataset.productHandle === product.handle;
      });
      if (!card) return false;

      card.hidden = false;
      card.classList.add('is-recent');
      var badge = card.querySelector('[data-br-card-badge]');
      if (badge) badge.textContent = root.dataset.recentBadge || '';
      selected.push(card);
      selectedHandles.push(product.handle);
      recentUsed += 1;
      return false;
    });

    fallbackCards.some(function (card) {
      var handle = card.dataset.productHandle;
      if (selected.length >= PERSONALIZED_LIMIT) return true;
      if (!handle || cartHandles.indexOf(handle) !== -1 || selectedHandles.indexOf(handle) !== -1) return false;
      card.hidden = false;
      selected.push(card);
      selectedHandles.push(handle);
      return false;
    });

    selected.forEach(function (card) { track.appendChild(card); });

    var title = root.querySelector('[data-br-personalized-title]');
    var count = root.querySelector('[data-br-personalized-count]');
    if (title) title.textContent = recentUsed > 0 ? root.dataset.recentTitle : root.dataset.defaultTitle;
    if (count) count.textContent = String(selected.length).padStart(2, '0');
    root.hidden = selected.length === 0;
  }

  function observeCartPersonalization() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.dataset.brPersonalizationObserved) return;
    drawer.dataset.brPersonalizationObserved = 'true';
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        initCartPersonalization();
      });
    }).observe(drawer, { childList: true, subtree: true });
  }

  function getSectionsToRender() {
    var ids = [];
    var drawer = document.querySelector('cart-drawer');
    var notification = document.querySelector('cart-notification');
    var bubble = document.getElementById('cart-icon-bubble');

    if (drawer) ids.push({ id: 'cart-drawer', selector: '#CartDrawer' });
    if (notification) ids.push({ id: 'cart-notification-product', selector: '#cart-notification-product' });
    if (bubble) {
      var headerSection = bubble.closest('.shopify-section');
      var headerSectionId = headerSection && headerSection.id
        ? headerSection.id.replace('shopify-section-', '')
        : 'cart-icon-bubble';
      ids.push({ id: headerSectionId, selector: '#cart-icon-bubble' });
    }
    return ids;
  }

  function findRenderedElement(sectionData, selector) {
    var keys = Object.keys(sectionData || {});
    for (var i = 0; i < keys.length; i += 1) {
      var html = sectionData[keys[i]];
      if (!html || html.indexOf(selector.slice(1)) === -1) continue;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var element = doc.querySelector(selector);
      if (element) return element;
    }
    return null;
  }

  function syncHeaderCartCountFromDrawer() {
    var headerCart = document.getElementById('cart-icon-bubble');
    var drawerCount = document.querySelector('#CartDrawer .br-cart-count');
    if (!headerCart || !drawerCount) return;

    var itemCount = parseInt(drawerCount.textContent, 10) || 0;
    var countBubble = headerCart.querySelector('.cart-count-bubble');

    if (itemCount < 1) {
      if (countBubble) countBubble.remove();
      return;
    }

    if (!countBubble) {
      countBubble = document.createElement('div');
      countBubble.className = 'cart-count-bubble';
      countBubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      headerCart.appendChild(countBubble);
    }

    var visibleCount = countBubble.querySelector('[aria-hidden="true"]');
    var accessibleCount = countBubble.querySelector('.visually-hidden');
    if (visibleCount) visibleCount.textContent = itemCount < 100 ? itemCount : '';
    if (accessibleCount) {
      accessibleCount.textContent = drawerCount.getAttribute('aria-label') || itemCount;
    }
  }

  function updateSectionHTML(sectionData) {
    if (!sectionData) return;

    var bubbleEl = document.getElementById('cart-icon-bubble');
    var newBubble = findRenderedElement(sectionData, '#cart-icon-bubble');
    if (bubbleEl && newBubble) bubbleEl.innerHTML = newBubble.innerHTML;

    var drawer = document.querySelector('cart-drawer');
    if (drawer && sectionData['cart-drawer']) {
      var drawerDoc = new DOMParser().parseFromString(sectionData['cart-drawer'], 'text/html');
      var newDrawer = drawerDoc.querySelector('#CartDrawer');
      var curDrawer = document.querySelector('#CartDrawer');
      if (newDrawer && curDrawer) {
        curDrawer.innerHTML = newDrawer.innerHTML;
        if (drawer.classList.contains('is-empty')) drawer.classList.remove('is-empty');
      }
      if (typeof drawer.open === 'function') {
        drawer.open();
      } else {
        drawer.classList.add('active', 'animate');
        drawer.setAttribute('open', '');
      }
    }

    syncHeaderCartCountFromDrawer();
    initCartPersonalization();
  }

  function setButtonState(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.classList.add('is-loading');
      btn.setAttribute('disabled', 'disabled');
      btn.dataset.prevText = btn.textContent;
    } else {
      btn.classList.remove('is-loading');
      btn.removeAttribute('disabled');
    }
  }

  function flashButton(btn, text) {
    if (!btn) return;
    var original = btn.dataset.prevText || btn.textContent;
    btn.textContent = text;
    setTimeout(function () {
      btn.textContent = original;
    }, 1600);
  }

  function quickAdd(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var sections = getSectionsToRender();
    var body = {
      items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      sections: sections.map(function (s) { return s.id; }).join(','),
      sections_url: window.location.pathname
    };

    setButtonState(btn, true);

    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        setButtonState(btn, false);
        if (data.status) {
          // Hata (ör. stok yok)
          flashButton(btn, data.description || 'Eklenemedi');
          return;
        }
        // Hamburger menü açıksa kapat (drawer içinden eklendiyse)
        var menuDrawer = document.querySelector('#Details-menu-drawer-container[open]');
        if (menuDrawer) menuDrawer.removeAttribute('open');

        if (data.sections) updateSectionHTML(data.sections);
        flashButton(btn, '✓ Eklendi');
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', { bubbles: true })
        );
      })
      .catch(function () {
        setButtonState(btn, false);
        flashButton(btn, 'Hata');
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-brillian-quick-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    quickAdd(btn);
  });

  /* ============================================================
     Hamburger menü — Öne Çıkan Ürünler yatay slider (2 satır)
     ============================================================ */
  function initDrawerFeaturedSlider() {
    document.querySelectorAll('[data-drawer-featured]').forEach(function (root) {
      var track = root.querySelector('[data-df-track]');
      if (!track) return;
      var nav = root.querySelector('[data-df-nav]');
      var prev = root.querySelector('[data-df-prev]');
      var next = root.querySelector('[data-df-next]');

      // Bir sayfa = görünen genişlik (~2 ürün)
      function page() {
        return Math.max(track.clientWidth, 1);
      }

      function setDisabled(el, state) {
        if (el) el.setAttribute('aria-disabled', state ? 'true' : 'false');
      }

      function update() {
        var overflow = track.scrollWidth > track.clientWidth + 4;
        if (nav) nav.hidden = !overflow;
        if (!overflow) return;
        var max = track.scrollWidth - track.clientWidth;
        setDisabled(prev, track.scrollLeft <= 4);
        setDisabled(next, track.scrollLeft >= max - 4);
      }
      root._dfUpdate = update;

      function go(dir) {
        track.scrollBy({ left: dir * page(), behavior: 'smooth' });
      }

      if (!root.dataset.dfInit) {
        root.dataset.dfInit = '1';

        // Oklar <span> (Dawn'ın buton-kapatma mantığına takılmasın diye).
        // stopPropagation ile tık drawer'ı kapatmaz.
        var bindArrow = function (el, dir) {
          if (!el) return;
          el.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (el.getAttribute('aria-disabled') === 'true') return;
            go(dir);
          });
          el.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
              e.preventDefault();
              e.stopPropagation();
              if (el.getAttribute('aria-disabled') === 'true') return;
              go(dir);
            }
          });
        };
        bindArrow(prev, -1);
        bindArrow(next, 1);

        track.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
        window.addEventListener('resize', update);
      }
      update();
    });
  }

  function refreshDrawerFeatured() {
    document.querySelectorAll('[data-drawer-featured]').forEach(function (r) {
      if (r._dfUpdate) r._dfUpdate();
    });
  }

  function initBrillianCommerce() {
    rememberCurrentProduct();
    initDrawerFeaturedSlider();
    initCartPersonalization();
    observeCartPersonalization();
  }

  if (document.readyState !== 'loading') initBrillianCommerce();
  else document.addEventListener('DOMContentLoaded', initBrillianCommerce);

  document.addEventListener('cart:refresh', initCartPersonalization);

  // Menü çekmecesi açılınca ölçüler netleşir — okları yeniden değerlendir
  document.addEventListener('toggle', function () {
    initDrawerFeaturedSlider();
    setTimeout(refreshDrawerFeatured, 60);
  }, true);
})();